import React from "react";
import { useL1L2Params } from "../hooks/useL1L2Params";

export const L1L2ParamsManager: React.FC = () => {
  const { l1, l2 } = useL1L2Params();

  // This is a utility component that manages L1/L2 params
  // It doesn't render anything visible, it just handles the params
  return null;
};

export default L1L2ParamsManager;
